import React, { useEffect, useState, useRef } from 'react'
import Nav from '../components/Nav'
import ModalNewChat from '../components/modals/ModalNewChat';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';
import getUser from "../services/decodeJWT";
import Loading from '../components/Loading';
import ConfirmButton from '../components/ConfirmButton';
import formatDate from '../services/formatDate';
import ModalCall from '../components/modals/ModalCall';
import ModalVideocall from '../components/modals/ModalVideocall';
import Instructions from '../services/Instructions';

const Chat = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const chatBodyRef = useRef(null);
    const textareaRef = useRef(null);

    const currentUser = getUser();
    const [cloneData, setCloneData] = useState({});
    const [chatData, setChatData] = useState({});
    const [clones, setClones] = useState([]);
    const [profileData, setProfileData] = useState({});
    const [loading, setLoading] = useState(false);
    const [typing, setTyping] = useState(false);
    const [mobileActive, setMobileActive] = useState(false);
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [chats, setChats] = useState([]);
    const [instructions, setInstructions] = useState('');
    const [search, setSearch] = useState('');
    const [filteredClones, setFilteredClones] = useState(clones);

    useEffect(() => {
        if (search.trim() === '') {
            setFilteredClones(clones);
        } else {
            const filtered = clones.filter(clone =>
            (clone?.data?.name?.toLowerCase().includes(search.toLowerCase()) ||
                clone?.data?.surname?.toLowerCase().includes(search.toLowerCase()))
            );
            setFilteredClones(filtered);
        }
    }, [search, clones]);


    const dropdownOptions = (chat = {}) => {
        const clone = chat?.data?.name;

        const options = [
            {
                label: 'Edit Clone',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pen" viewBox="0 0 16 16">
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z" />
                    </svg>
                ),
                action: `/edit-clone/${clone?._id}`,

            },
            {
                label: 'View Family Tree',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diagram-2" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM3 11.5A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
                    </svg>
                ),
                action: `/family-tree/${clone?._id}`,
            },
        ]
        return options
    };

    const activeChat = chats.find((chat) =>
        filteredClones.some((clone) => clone._id === chat?.data?.name?._id)
    );


    const getProfile = async () => {
        if (!profileData?.contents?.length) {
            try {
                const response = await ApiService.get(`/cms/profiles?author=${currentUser?._id}&name=${currentUser?.username}`);
                const profile = response?.contents?.[0]?.data;
                if (profile) setProfileData(profile);
            } catch (error) {
                console.error("Error fetching profile:", error);
            }

        }
    };

    const getClone = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const response = await ApiService.get(`/cms/clones?id=${id}`);
            const clone = response?.contents?.[0]?.data;
            if (clone) setCloneData(clone);
        } catch (error) {
            console.error("Error fetching clone data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getClones = async () => {
        try {
            setLoading(true);
            const response = await ApiService.get(`/cms/clones?limit=1000&author=${currentUser?._id}`);
            setClones(response?.contents || []);
        } catch (error) {
            console.error("Error fetching clones:", error);
        } finally {
            setLoading(false);
        }
    };

    const getChats = async () => {
        try {
            const response = await ApiService.get(`/cms/chats?author=${currentUser?._id}&limit=100`);
            setChats(response?.contents?.filter(item => item?.data?.name?._id) || []);
        } catch (error) {
            console.error("Error fetching chats data:", error);
        }
    };

    const getChat = async () => {
        setMessages([]);
        if (!id) return;
        try {
            const response = await ApiService.get(`/cms/chats?clone_id=${id}`);
            const chatContent = response?.contents?.[0]?.data?.context;
            const parsedMessages = chatContent ? JSON.parse(chatContent) : [];
            setMessages(parsedMessages);
            setChatData({ ...chatData, _id: response?.contents?.[0]?._id });
        } catch (error) {
            console.error("Error fetching chat data:", error);
            setMessages([]);
        }
    };

    useEffect(() => {

        setInstructions(Instructions(cloneData, profileData));

        getChat();
        getChats();

    }, [cloneData])

    const letsChat = async () => {
        if (!message.trim()) return;

        try {
            const payload = {
                message: message,
                context: messages,
                instructions: instructions
            }

            setMessages([...messages, { question: message }])

            setTimeout(() => {
                setTyping(true);
            }, [300])

            setMessage('');

            const chat = await ApiService.post(`/cms/ai/chat`, payload);

            setTyping(false);

            setMessages(() => chat?.context || []);
            handleSave(chat?.context);

        } catch (err) {
            console.error("Error during fetching clone data:", err);
            setTyping(false);
        } finally {
            setTyping(false);
        }
    };

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        adjustTextareaHeight();
    }, [message]);


    const handleSave = async (context) => {

        try {
            const payload = {
                data: {
                    ...chatData,
                    name: id,
                    clone_id: id,
                    context: JSON.stringify(context)
                },
            };

            if (chatData?._id) {
                const response = await ApiService.put(`/cms/chats/${chatData?._id}`, payload);
            } else {
                const response = await ApiService.post(`/cms/chats`, payload);
                setChatData({ ...chatData, _id: response?.newObject?._id })
            }

            await getChats();

        } catch (error) {
            console.error("Error saving clone:", error);
        }
    };

    useEffect(() => {
        getProfile();
        getClone();
        getClones();
        getChat();
    }, [navigate]);

    useEffect(() => {
        if (id) {
            setMobileActive(true)
        } else {
            setMobileActive(false)
        }

    }, [id])

    const getLastMessage = (id, chatContext) => {

        let context = chatContext;

        if (id == chatData?._id) {
            context = messages;
        } else {
            try {
                context = JSON.parse(context);
            } catch (error) {
                console.error("Invalid JSON context:", error);
                context = [];
            }
        }

        if (!Array.isArray(context) || context.length === 0) {
            return {};
        }

        return context[context?.length - 1];
    };

    const handleDelete = async (id) => {
        try {
            await ApiService.delete(`/cms/chats/${id}`);
            toast.success("Chat successfully deleted!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            navigate('/chat');
        } catch (error) {
            console.error("Error deleting chat:", error);
            toast.error("Failed to delete this chat. Please try again.", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [messages, id]);


    return (
        <>

            <Loading status={loading} blur={true}>
                <div className="tyn-root" onKeyDown={(e) => e.key === 'Enter' && letsChat()}>
                    <Nav />
                    <div className="tyn-content tyn-content-full-height tyn-chat has-aside-base">
                        <div className="tyn-aside tyn-aside-base">
                            <div className="tyn-aside-head">
                                <div className="tyn-aside-head-text">
                                    <h3 className="tyn-aside-title">Chats</h3>
                                </div>
                                <div className="tyn-aside-head-tools">
                                    <ul className="link-group gap gx-3">
                                        <li className="dropdown">
                                            <button className="link" data-bs-toggle="modal" data-bs-target="#newChat">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                                </svg>
                                                <span>New</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tyn-aside-body" data-simplebar>
                                {/* SEARCHBAR */}
                                <div className="tyn-aside-search">
                                    <div className="form-group tyn-pill">
                                        <div className="form-control-wrap">
                                            <div className="form-control-icon start">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                </svg>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid"
                                                id="search"
                                                placeholder="Search contact / chat"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-content">
                                    <div className="tab-pane show active" id="all-chats" tabIndex="0" role="tabpanel">

                                        {chats?.length >= 1 ? (
                                            <ul className="tyn-aside-list">
                                                {chats
                                                    .filter((chat) => filteredClones.some((clone) => clone._id === chat?.data?.name?._id))
                                                    .map((chat) => (
                                                        <li key={chat?._id} className={`tyn-aside-item js-toggle-main ${chat?.unread ? "unread" : ""} ${chat?.data?.name?._id == id ? 'active' : ''}`}>
                                                            <div onClick={() => navigate(`/chat/${chat?.data?.name?._id}`)} className="w-100 p-0 cursor-pointer">
                                                                <div className="tyn-media-group">
                                                                    <div className="tyn-media tyn-size-lg">
                                                                        <img src={chat?.data?.name?.data?.picture?.media || '/images/avatar/avatar-default.jpg'} alt={chat?.data?.name?.data?.name} />
                                                                    </div>
                                                                    <div className="tyn-media-col">
                                                                        <div className="tyn-media-row d-flex justify-content-between align-items-center">
                                                                            <h6 className="name text-capitalize">{chat?.data?.name?.data?.name} {chat?.data?.name?.data?.surname}</h6>
                                                                            <span className="meta">{getLastMessage(chat?._id, chat?.data?.context)?.time ? formatDate(getLastMessage(chat?._id, chat?.data?.context)?.time) : '00/00/00'}</span>
                                                                        </div>

                                                                        <div className="tyn-media-row has-dot-sap d-flex">
                                                                            <p className="content">{getLastMessage(chat?._id, chat?.data?.context)?.answer || 'Typing...'}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="tyn-media-option tyn-aside-item-option">
                                                                        <ul className="tyn-media-option-list">
                                                                            <li className="dropdown">
                                                                                <div className="btn btn-icon btn-white btn-pill dropdown-toggle" data-bs-toggle="dropdown" data-bs-offset="0,0" data-bs-auto-close="outside">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                                                                                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                                                                                    </svg>
                                                                                </div>
                                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                                    <ul className="tyn-list-links">
                                                                                        {dropdownOptions(chat)?.map((option, index) =>
                                                                                            option.type === 'divider' ? (
                                                                                                <li key={index} className="dropdown-divider"></li>
                                                                                            ) : (
                                                                                                <li key={index}>
                                                                                                    <Link to={option.action} data-bs-toggle={option.dataToggle || undefined}>
                                                                                                        {option.icon}
                                                                                                        <span>{option.label}</span>
                                                                                                    </Link>
                                                                                                </li>
                                                                                            )
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                            </ul>
                                        ) : (
                                            <p className='text-center mt-5' style={{ fontSize: "14px" }}>There's no conversation yet.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {cloneData.name ? (
                            <div className={`tyn-main tyn-content-inner p-0 ${mobileActive ? 'main-shown' : ''}`} id="tynMain">

                                {/* CHAT HEAD */}
                                <div className="tyn-chat-head d-flex justify-content-between">

                                    <div className="left-side-head tyn-media-group">
                                        <ul className="tyn-list-inline d-md-none ms-n1">
                                            <li>
                                                <Link className="btn btn-icon btn-md btn-pill btn-transparent js-toggle-main" to="/chat">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                                    </svg>
                                                </Link>
                                            </li>
                                        </ul>
                                        <div className="tyn-media tyn-size-lg d-none d-sm-inline-flex">
                                            <img src={cloneData?.picture?.media || '/images/avatar/avatar-default.jpg'} alt="" />
                                        </div>
                                        <div className="tyn-media tyn-size-rg d-sm-none">
                                            <img src={cloneData?.picture?.media || '/images/avatar/avatar-default.jpg'} alt="" />
                                        </div>
                                        <div className="tyn-media-col">
                                            <div className="tyn-media-row">
                                                <h6 className="name text-capitalize">
                                                    {cloneData?.name} {cloneData?.surname?.length > 15 ? cloneData?.surname.substring(0, 15) + '...' : cloneData?.surname}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="right-side-head">
                                        <ul className="tyn-list-inline gap gap-2 ms-auto chat-btn-menu">
                                            <li>
                                                <Link to="/calling-screen" data-bs-toggle="modal" data-bs-target="#callingScreen" className="btn btn-icon btn-light">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                                    </svg>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/video-calling-screen" data-bs-toggle="modal" data-bs-target="#videoCallingScreen" className="btn btn-icon btn-light">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-camera-video-fill" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2z" />
                                                    </svg>
                                                </Link>
                                            </li>
                                            <li>
                                                {
                                                    chatData?._id && (
                                                        <ConfirmButton
                                                            redirect="/chat"
                                                            label="Delete"
                                                            title={`${cloneData?.name}'s Chat`}
                                                            action={handleDelete}
                                                            data={chatData?._id}
                                                            message="Once you delete this chat, it cannot be restored. Are you sure you want to proceed?"
                                                            template=
                                                            {<button className="btn btn-icon btn-light">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                                                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                                                                </svg>
                                                            </button>}
                                                        />
                                                    ) || (<></>)
                                                }
                                            </li>

                                            <li className="dropdown">
                                                <Link to="/" data-bs-toggle="dropdown" data-bs-offset="0,0" data-bs-auto-close="outside" className="btn btn-icon btn-light">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                    </svg>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end mt-2">

                                                    <ul className="tyn-list-links">
                                                        {activeChat && dropdownOptions(activeChat)?.map((option, index) =>
                                                            option.type === 'divider' ? (
                                                                <li key={index} className="dropdown-divider"></li>
                                                            ) : (
                                                                <li key={index}>
                                                                    <Link to={option.action} data-bs-toggle={option.dataToggle || undefined}>
                                                                        {option.icon}
                                                                        <span>{option.label}</span>
                                                                    </Link>
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                {/* CHAT BODY */}
                                <div className="tyn-chat-body js-scroll-to-end" id="tynChatBody" ref={chatBodyRef}>
                                    <div className="tyn-reply" id="tynReply">
                                        {
                                            typing ?
                                                (
                                                    <div className="tyn-reply-item incoming" key={`${cloneData?.name}-type_id`}>
                                                        <div className="tyn-reply-group">
                                                            <div className="tyn-reply-bubble">
                                                                <div className="tyn-reply-text tyn-reply-bubble typing-indicator ">
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (<></>)
                                        }

                                        {messages?.length && messages?.slice()?.reverse()?.map((message, index) =>
                                        (
                                            <div key={index} className='d-flex flex-column-reverse'>

                                                {/* MESSAGE RECEIVED */}
                                                {
                                                    message?.answer ?
                                                        (
                                                            <div className="tyn-reply-item incoming" key={`receiver-${index}`}>
                                                                <div className="tyn-reply-group">
                                                                    <div className="tyn-reply-bubble">
                                                                        <div className="tyn-reply-text">{message?.answer}</div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (<></>)
                                                }


                                                {/* MESSAGE SENT */}
                                                {
                                                    message?.question ?
                                                        (
                                                            <div className="tyn-reply-item outgoing" key={`sender-${index}`}>
                                                                <div className="tyn-reply-group">
                                                                    <div className="tyn-reply-bubble">
                                                                        <div className="tyn-reply-text">{message?.question}</div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (<></>)
                                                }

                                            </div>
                                        )) || (<></>)
                                        }
                                        {/* DATE SEPARATOR */}
                                        {/* <div className="tyn-reply-separator">May 10, 2022, 11:14 AM</div> */}

                                    </div>
                                </div>

                                {/* CHAT FOOTER */}
                                <div className="tyn-chat-form">
                                    <div className="tyn-chat-form-enter">
                                        <textarea
                                            ref={textareaRef}
                                            className="tyn-chat-form-input"
                                            placeholder="Send Message..."
                                            rows="1"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    letsChat();
                                                }
                                            }}
                                            style={{ border: "none", resize: "none" }}
                                        />
                                        <ul className="tyn-list-inline me-n2 my-1">
                                            <li>
                                                <button
                                                    id='tynChatSend'
                                                    className="btn btn-icon btn-white btn-md btn-pill send-btn"
                                                    disabled={!message.trim()}
                                                    onClick={letsChat}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send-fill" viewBox="0 0 16 16">
                                                        <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
                                                    </svg>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="tyn-main tyn-chat-content d-flex justify-content-center" id="tynMain">
                                <div className="empty-clone-message d-flex justify-content-center flex-column align-items-center ">
                                    <div className="home-logo d-flex align-items-center ">
                                        <img src="/images/logo/bardo-icon-white.png" alt="" style={{ width: "96px", height: "96px" }} />
                                        <h1 className="text-white ps-3" style={{ fontFamily: "Inter, sans-serif", fontWeight: "700", fontSize: "98px" }}>Bardo</h1>
                                    </div>
                                    {
                                        chats?.length >= 1 ? (
                                            <div className="d-flex align-items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                                </svg>
                                                <h4 className="text-white m-0 text-center ps-3" style={{ fontSize: "16px" }}>Select a chat</h4>
                                            </div>
                                        ) : (
                                            <>
                                                <h4 className="text-white m-0 text-center" style={{ fontSize: "16px" }}>Search your clone and start chatting!</h4>
                                                <Link to='/' className="btn btn-secondary mt-5" data-bs-toggle="modal" data-bs-target="#newChat" aria-label="Add New Clone">Chat with a clone</Link>
                                            </>
                                        )
                                    }

                                </div>
                            </div>
                        )}

                    </div>

                </div >
            </Loading>

            <ModalNewChat clones={clones} />
            <ModalCall cloneData={cloneData} />
            <ModalVideocall cloneData={cloneData} />
        </>

    )
}

export default Chat